/* 语音通知 */
import request from '@/utils/request'
import { getToken } from '../utils/auth'
// queryvoicemessagebylevel
export function queryvoicemessagebylevel (data, param) {
  return request({
    url: '/queryvoicemessagebylevel',
    method: 'post',
    params: { token: getToken(), page: param.page, size: param.size },
    data
  })
}
// 查询语音信息(分页设计，必要时带上page size)
export function queryvoicemessage (data, param) {
  return request({
    url: '/queryvoicemessage',
    method: 'post',
    params: { token: getToken(), page: param.page, size: param.size },
    data
  })
}
// 按照标题，查找语音信息，支持分页
export function searchvoicemessage (data, param) {
  return request({
    url: '/searchvoicemessage',
    method: 'post',
    params: { token: getToken(), page: param.page, size: param.size },
    data
  })
}
// 根据消息ID，查找消息详情(分页设计，必要时带上page size)
export function queryvoicemessagestatusbyvmid (data, param) {
  return request({
    url: '/queryvoicemessagestatusbyvmid',
    method: 'post',
    params: { token: getToken(), page: param.page, size: param.size },
    data
  })
}
// 根据 设备 ID，查找消息详情(分页设计，必要时带上page size)
export function queryvoicemessagestatusbydid (data, param) {
  return request({
    url: '/queryvoicemessagestatusbydid',
    method: 'post',
    params: { token: getToken(), page: param.page, size: param.size },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/voice.js